export default __webpack_public_path__ + "static/media/857.f6a437e2.png";